import p from '../../styles/Profile.module.css';
import BackHome from "../../components/BackHome";

function Windows() {
    const steps = [
        { text: 'Скачайте программу v2rayN или Nekoray для Windows', href: 'https://github.com/2dust/v2rayN/releases' },
        { text: 'Распакуйте архив в удобное место и запустите приложение', href: null },
        { text: 'Скопируйте вашу ссылку на подписку из личного кабинета', href: null },
        { text: 'В программе нажмите "Серверы" (Servers) → "Импортировать из буфера обмена"', href: null },
        { text: 'Нажмите кнопку "Подключить" (или выберите сервер и нажмите Enter) для запуска VPN', href: null },
    ];

    return (
        <>
            <BackHome />
            <div className={p.page}>
                <div className={p.section}>
                    <p className={p.section_title} style={{ cursor: 'default' }}>
                        Инструкция по настройке Windows
                    </p>
                    
                    <div className={p.steps}>
                        {steps.map((step, i) => (
                            <div className={p.step_row} key={i}>
                                <div className={p.step_num}>{i + 1}</div>
                                <p className={p.step_text}>
                                    {step.href ? (
                                        <a href={step.href} className={p.step_link} target="_blank" rel="noreferrer">
                                            {step.text}
                                        </a>
                                    ) : (
                                        step.text
                                    )}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Windows;